import React from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertTriangle } from 'lucide-react';
import { Button } from '../components/ui/Button';

export const NotFound: React.FC = () => {
  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-20 h-20 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <AlertTriangle className="w-10 h-10 text-secondary-400" />
        </div>
        <h1 className="text-6xl font-bold text-secondary-300 mb-2">404</h1>
        <h2 className="text-xl font-semibold text-secondary-900 mb-2">Página no encontrada</h2>
        <p className="text-secondary-500 mb-6">La página que buscas no existe o fue movida.</p>
        <Link to="/">
          <Button leftIcon={<Home className="w-4 h-4" />}>Volver al inicio</Button>
        </Link>
      </div>
    </div>
  );
};
